import React from "react";
import Const from './Const';
import { messageModalWindow } from './Utils.js';
import { renderVideoPlayerWrapperU } from '../utils/VideoPlayerUtils.js';

class ImageUpload extends React.Component {
	constructor(props) {
		super(props);
			this.state = {
				file: '',
				imagePreviewUrl: '',
				isError: false,
				playing : true,
				messageModal : false,
				header : '',
			    text : '',
				parent : null,
				videoFile : null
			};
	}

	disableElements() { 
		let imageDiv = document.getElementById('imageDiv');

		imageDiv.style.opacity = Const.REDUCED_OPACITY;
	}

	imagePreview(imageUrl) {
		return (
			<div className="previewComponent">
				<div id="imageDiv" className="imgPreview">
					<div className="image-parent-create-post">
						<img alt="your upload" src={ imageUrl } className="img-fluid"/>
					</div>
				</div>
			</div>
		);
	}

	videoPreview(videoUrl, playing) {
		return (
			<div id="previewDiv" className="previewComponent">
				<div id="imageDiv" className="imgPreview">
					<div className="image-parent-create-post">
					  { renderVideoPlayerWrapperU(videoUrl, playing, false, this) }
					</div>
				</div>
			</div>
		);
	}

	defaultPreview() {
		return (
			<div className="previewComponent">
				<div id="imageDiv" className="imgPreview">
				</div>
			</div>
		);
	}

	render() {
		let { imagePreviewUrl, videoPreviewUrl, playing } = this.state;

		return (
			<>
				{
					imagePreviewUrl && this.imagePreview(imagePreviewUrl)
				}

				{
					videoPreviewUrl && this.videoPreview(videoPreviewUrl, playing)
				}

				{
					!imagePreviewUrl && !videoPreviewUrl && this.defaultPreview()
				}
				
				<div>
					{
					messageModalWindow(this, this.state.header, this.state.text)
					}
				</div>
			</>
		)
	}
}

export default ImageUpload;